import { useTranslation } from 'react-i18next';
import './ModuleProgress.scss';
import '../../../Common.scss';
import Loader from '@trackman/web-shared-components/components/Loader/Loader';
import { Tab, Tabs } from '@trackman/web-shared-components';
import { Subtitle } from 'components/TextComps/Subtitle';
import { StudentProgress } from '../StudentProgress/StudentProgress';
import { ClassProgress } from '../ClassProgress/ClassProgress';
import { NoStudentsFound } from '../../Students/NoStudentsFound/NoStudentsFound';
import { useGetModuleProgress } from 'queryHooks/Organization/Progress/useGetModuleProgress';

type Props = {
  selectedClassId: string;
  selectedModuleId: string;
  selectedModuleName: string;
  isModuleProgressQueryEnabled: boolean;
  selectedProgressOverviewIndex: number;
  studentsFilter: string;
  setSelectedProgressOverviewIndex: (index: number) => void;
};

export const ModuleProgress = ({
  selectedClassId,
  selectedModuleId,
  selectedModuleName,
  isModuleProgressQueryEnabled,
  selectedProgressOverviewIndex,
  studentsFilter,
  setSelectedProgressOverviewIndex,
}: Props) => {
  const { t } = useTranslation();

  const { data: moduleProgress, isPending: isModuleProgressPending } = useGetModuleProgress(
    selectedClassId,
    selectedModuleId,
    isModuleProgressQueryEnabled
  );

  const filteredModuleProgress =
    moduleProgress?.filter((student) => student.name.toLowerCase().includes(studentsFilter.toLowerCase())) ?? [];
  return (
    <div className='module-progress-table-wrapper organization-tab-content'>
      {isModuleProgressPending ? (
        <div className='new-loader-wrapper'>
          <Loader size='large' />
        </div>
      ) : (
        <>
          <div className='module-progress-table-header'>
            <div className='module-progress-table-title'>
              <span>{t('Module', { ns: 'organizationPage' })}</span>
              <Subtitle>
                <>{selectedModuleName}</>
              </Subtitle>
            </div>
            <div className='module-progress-table-tabs'>
              <Tabs
                value={selectedProgressOverviewIndex}
                onChange={(event, newValue: number) => setSelectedProgressOverviewIndex(newValue)}
              >
                <Tab label={t('StudentProgress', { ns: 'organizationPage' })} />
                <Tab label={t('ClassProgress', { ns: 'organizationPage' })} />
              </Tabs>
            </div>
          </div>

          <>
            {selectedProgressOverviewIndex === 0 && (
              <div role='tabpanel' id='students-progress-tab' aria-labelledby='students-progress-tab'>
                {!moduleProgress?.length ? <NoStudentsFound /> : <StudentProgress filteredModuleProgress={filteredModuleProgress} />}
              </div>
            )}
            {selectedProgressOverviewIndex === 1 && (
              <div role='tabpanel' id='class-progress-tab' aria-labelledby='class-progress-tab'>
                {!moduleProgress?.length ? (
                  <NoStudentsFound />
                ) : (
                  <ClassProgress moduleProgress={moduleProgress} classId={selectedClassId} />
                )}
              </div>
            )}
          </>
        </>
      )}
    </div>
  );
};
